import PageContext from 'helpers/context/Page/PageContext';
import { Backdrop, CircularProgress } from "@mui/material";
import TrapFocus from "@mui/base/TrapFocus";

function WaitOverlay () {

return <>
    <PageContext.Consumer>
    {pageInfo => (
        <Backdrop
            open={pageInfo.waitVisible}
            onClick={() => {}}
            style={{transitionDelay:".75s", zIndex:99999}}
        >
            <TrapFocus open={pageInfo.waitVisible}>
                <CircularProgress color="inherit" style={{ outline: 'none' }}/>
            </TrapFocus>     
        </Backdrop>
        )
    }   
    </PageContext.Consumer>
</>

}

export default WaitOverlay;